'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _adminsByCategoryPie = require('./admins-by-category-pie.html');

var _adminsByCategoryPie2 = _interopRequireDefault(_adminsByCategoryPie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _adminsByCategoryPie2.default,
  controller: function () {
    function AdministrationsByCategoryPieComponent($scope, LoadingService, AdminsByCategoryPieService, ToastService) {
      'ngInject';

      _classCallCheck(this, AdministrationsByCategoryPieComponent);

      Object.assign(this, {
        $scope: $scope,
        LoadingService: LoadingService,
        AdminsByCategoryPieService: AdminsByCategoryPieService,
        ToastService: ToastService
      });
    }

    _createClass(AdministrationsByCategoryPieComponent, [{
      key: 'getChartConfig',
      value: function getChartConfig() {
        return {
          title: {
            text: 'Administrations by Product Category'
          },
          subtitle: {
            text: 'NASC Adverse Event Reporting System'
          },
          xAxis: {
            type: 'category'
          },
          yAxis: {
            title: {
              text: 'Administrations (in mils)'
            }
          },
          legend: {
            itemWidth: 180,
            itemDistance: 0,
            itemStyle: {
              fontSize: '14px'
            }
          },
          plotOptions: {
            pie: {
              size: 500,
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                enabled: true,
                format: '{point.name}: {point.percentage:.1f}%',
                style: {
                  fontSize: '14px'
                }
              },
              showInLegend: true
            }
          },
          tooltip: {
            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y:,.2f} mil</b></td></tr>',
            footerFormat: '</table>',
            shared: true,
            useHTML: true
          }
        };
      }
    }, {
      key: '$onInit',
      value: function $onInit() {
        this.chartConfig = this.getChartConfig();
      }
    }, {
      key: 'generateReport',
      value: function generateReport(_ref) {
        var _this = this;

        var params = _ref.params;

        this.LoadingService.start();
        this.AdminsByCategoryPieService.getReport(params).then(function (_ref2) {
          var series = _ref2.series,
              drilldown = _ref2.drilldown;

          _this.chartConfig = undefined;
          _this.$scope.$apply();
          _this.chartConfig = _extends({}, _this.getChartConfig(), {
            series: series,
            drilldown: drilldown
          });
        }).catch(function (error) {
          return _this.ToastService.showError(error);
        }).finally(function () {
          _this.LoadingService.stop();
          _this.$scope.$apply();
        });
      }
    }]);

    return AdministrationsByCategoryPieComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/reports/admins-by-category-pie/admins-by-category-pie.component.js